import * as React from 'react';
import * as classnames from 'classnames/bind';
import SVGInline from 'react-svg-inline';

import styles from './List.scss';
import checkIcon from '../Icon/check.svg';

const cx = classnames.bind(styles);

export interface ListItemProps {
  ordered?: boolean;
  className?: string;
}

const ListItem: React.SFC<ListItemProps> = ({ ordered, children, className }) => (
  <li className={cx('listItem', { ordered }, className)}>
    {!ordered && <SVGInline svg={checkIcon} className={styles.listMark} />}
    <div>{children}</div>
  </li>
);

export default ListItem;



// WEBPACK FOOTER //
// /www/client/src/components/List/ListItem.tsx